import { FC } from 'react';
import { Link } from 'react-router-dom';
import { CompanyGroup } from '../utils/derive';
import { SEVERITY } from '../utils/aging';
import { COMPANY_DETAILS_ROUTE } from '../../../../utils/constant';
import DetailTable from './DetailTable';

// Whole-dollar formatter for company summaries
function money0(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

interface CompanyGroupCardProps {
  group: CompanyGroup;
  isOpen: boolean;
  onToggle: () => void;
  today: Date;
}

const CompanyGroupCard: FC<CompanyGroupCardProps> = ({ group, isOpen, onToggle, today }) => {
  const segTotal = group.segments.reduce((s, seg) => s + seg.amount, 0);

  return (
    <div className="ia-company-card">
      <div className="ia-company-header" onClick={onToggle}>
        <div className="ia-company-left">
          {group.companyId && group.companyId !== '__unknown__' ? (
            <Link
              className="ia-company-name ia-link"
              to={`${COMPANY_DETAILS_ROUTE}/${group.companyId}`}
              onClick={(e) => e.stopPropagation()}
            >
              {group.companyName}
            </Link>
          ) : (
            <span className="ia-company-name">{group.companyName}</span>
          )}
          <span className="ia-company-row-count">{group.rows.length}</span>
        </div>

        <div className="ia-company-right">
          {group.pastDue > 0 && (
            <div className="ia-company-stat">
              <div className="stat-label">Past Due</div>
              <div className="stat-value past-due-value">{money0(group.pastDue)}</div>
            </div>
          )}
          <div className="ia-company-stat">
            <div className="stat-label">Outstanding</div>
            <div className="stat-value">{money0(group.outstanding)}</div>
          </div>
          <span className={`ia-chevron${isOpen ? ' open' : ''}`}>▼</span>
        </div>
      </div>

      {/* Mini segment bar */}
      {group.segments.length > 0 && segTotal > 0 && (
        <div className="ia-company-seg-bar">
          {group.segments.map((seg) => (
            <div
              key={seg.key}
              className="ia-seg-chunk"
              style={{
                width: `${(seg.amount / segTotal) * 100}%`,
                background: SEVERITY[seg.key].bar,
              }}
            />
          ))}
        </div>
      )}

      {/* Lazy-render: only mount DetailTable when open */}
      {isOpen && <DetailTable rows={group.rows} today={today} />}
    </div>
  );
};

export default CompanyGroupCard;
